import { valueOrNull } from "@/shared/value";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { FileTypeIcon } from "@/modules/documents/shared/ui/file-type-icon";
import { FolderIcon } from "../folder-icon/folder-icon";
import { CompanyDocumentTreeNode } from "../../model/types";
import { isFolderNode, isHiddenNode } from "../../utils/tree-node-guards";

export function TreeNodeIcon({
  node,
  expanded,
  className,
}: {
  node: CompanyDocumentTreeNode;
  expanded?: boolean;
  className?: string;
}) {
  // Закрытый защитой узел со штатной иконкой папки визуально неотличим от доступной:
  // его пробуют открыть и перетащить. Значок сразу показывает, что доступа нет.
  if (isHiddenNode(node)) {
    return <EyeInvisibleOutlined className={className} />;
  }

  if (isFolderNode(node)) {
    return (
      <FolderIcon
        color={valueOrNull(node.folder)?.color}
        expanded={expanded}
        className={className}
      />
    );
  }

  return (
    <FileTypeIcon
      fileName={valueOrNull(node.document)?.file.fileName}
      className={className}
    />
  );
}
